export default "__VITE_ASSET__D_y32lBQ__"